import React from 'react';
import { connect } from 'react-redux'
import agent from '../../agent'
import '../../styles/components.css'
import '../../styles/main.css'
import '../../styles/responsive.css'
import '../../styles/styleAdmin.css'

import ReactLoading from 'react-loading';
import { AlertList } from "react-bs-notifier";
import { Dropdown } from 'react-bootstrap';

const mapStateToProps = state => (
  Object.assign({}, state, {
  })
);

const mapDispatchToProps = dispatch => ({
});

class EditStatus extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      delayTimer: null, school_id: 0,
      loaderspiner: false, view_mode: 'readonly', is_group_sync: 0, config_school_group: {},saupdatestatus:false,
      status_id: 0, status_name: '', status_state: '', applied_to: '', terminating: 0, initial: 0, block_access: 0, status_comment: 0, system_only: 0, withdrawn_enrollment: 0, off_limit: 0,
      showAlert: false, position: "bottom-right", error_message: "", rule_select: [], status_select: [], object_type: 0, applyto_list: [],
      alerts: [{
        id: (new Date()).getTime(),
        type: "success",
        message: 'Saved Successfully.'
      }],
    }
    this.handleCheckbox = (field, ev) => {
      this.setState({ [field]: ev.target.checked ? ev.target.value : 0 }, () => {
      });
    }
    this.handleInput=(field, ev)=>{
			this.setState({ [field]: ev.target.value });
    }
    this.get_configuration_by_schoolid = () => {
      let params = {
        school_id: this.state.school_id
      };
      agent.superadmin.get_configuration_by_schoolid(params).then(datas => {
        //console.log(datas)
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            config_school_group: data
          });
        }
      })
    }
    this.get_applyto_list = () => {
      let params = {
      };
      for (let prop in this.state.searchFields) {
        params[prop] = this.state.searchFields[prop];
      }
      this.setState({ loaderspiner: true });
      agent.admin.get_applyto_list(params).then(datas => {
        //console.log(datas)
        this.setState({ loaderspiner: false });
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            applyto_list: data
          });
        }
      })
    }
    this.get_status_detail = (status_id) => {
      let params = {
        status_id: status_id
      };
      this.setState({ loaderspiner: true });
      agent.admin.get_status_detail(params).then(datas => {
        this.setState({ loaderspiner: false });
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            status_id: data.status_id,
            status_name: data.status_name,
            status_state: data.status_state,
            applied_to: data.applied_to,
            terminating: data.terminating,
            block_access: data.block_access,
            initial: data.initial,
            status_comment: data.status_comment,
            // system_only: data.system_only,
            withdrawn_enrollment: data.withdrawn_enrollment,
            off_limit: data.off_limit,
          }, () => {
          });
        }
      })
    }
    this.save_status = () => {
      let result = this.checkConfig();
      if (!result.confirm) return;

      let params = {
        status_id: this.state.status_id,
        school_id: this.state.school_id,
				status_name: this.state.status_name,
				status_state: this.state.status_state,
				applied_to: this.state.applied_to,
				terminating: this.state.terminating,
				block_access: this.state.block_access,
				initial: this.state.initial,
				status_comment: this.state.status_comment,
        // system_only: this.state.system_only,
        withdrawn_enrollment: this.state.withdrawn_enrollment,
        off_limit: this.state.off_limit,
        is_group_sync: result.is_group_sync,
      };
      this.setState({ loaderspiner: true, error_message: '' });
      agent.admin.save_status(params).then(datas => {
        this.setState({ loaderspiner: false });
        if (datas.status === true) {
          this.setState({ 
            showAlert:true,
            status_id: datas.data.status_id
          });
        } else {
          this.setState({
            error_message: datas.message
          })
        }
      })
    }
		this.showModalEror=(message)=>{
			this.setState({isOpenModal:true,msg:message})
		}
    this.hideEditSection=()=>{
      this.props.onCallback();
    }
    this.checkConfig = () => {
      let configSchoolGroup = this.state.config_school_group;
      if (configSchoolGroup.hasOwnProperty('statuses') && configSchoolGroup.statuses == 1 && this.state.is_group_sync != 1) {
        let confirm = window.confirm("This school belongs to school group " + configSchoolGroup.school_group_name + ".  Any changes made here will be applied to all schools in this school group. Do you want to proceed?");
        let is_group_sync = confirm ? 1 : 0;
        this.setState({ is_group_sync: is_group_sync });
        return {'confirm': confirm, 'is_group_sync': is_group_sync};
      } else {
        return {'confirm': true, 'is_group_sync': this.state.is_group_sync};
      }
    }
    this.editItem = (view_mode) => {
      let result = this.checkConfig();
      if (!result.confirm) return;
        
      this.setState({ view_mode: view_mode, is_group_sync: result.is_group_sync }, () => {
      });
    }
    this.delete_status = (status_id) => {
      let configSchoolGroup = this.state.config_school_group;
      let is_group_sync = 0;
      let confirm;
      if (configSchoolGroup.hasOwnProperty('statuses') && configSchoolGroup.statuses == 1) {
        confirm = window.confirm("This school belongs to school group " + configSchoolGroup.school_group_name + ".  Any changes made here will be applied to all schools in this school group. Do you want to proceed?");
        is_group_sync = confirm ? 1 : 0;
        if (!confirm) return;
      } else {
        is_group_sync = 0;
        confirm = window.confirm("Delete this record ?");
        if (!confirm) return;
      }
      let params = {
        status_id: status_id,
        is_group_sync: is_group_sync,
      }
      this.setState({ loaderspiner: true });
      agent.admin.delete_status(params).then(datas => {
        //console.log(datas)
        if (datas.status === true) {
          this.hideEditSection();
          this.setState({
            loaderspiner: false,
            showAlert: true,
          });
        }
      })
    }
  }
	onAlertDismissed(alert) {
		const alerts = this.state.alerts;

		// find the index of the alert that was dismissed
		const idx = alerts.indexOf(alert);

		if (idx >= 0) {
			this.setState({
				// remove the alert from the array
				alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
			});
		}
	}
  componentDidMount() {
    let status_id = this.props.status_id;
    let school_id = this.props.school_id;
    let applied_to = this.props.applied_to;
    let saupdatestatus = false;
      let setting_config = JSON.parse(window.localStorage.getItem('user_settings'));
      if (setting_config != undefined && setting_config != null && setting_config != '') {
        saupdatestatus = setting_config.hasOwnProperty('saupdatestatus') ? setting_config.saupdatestatus : false;    
    }
    this.setState({ status_id: status_id, applied_to: applied_to, school_id: school_id, saupdatestatus: saupdatestatus, }, () => {
      this.get_status_detail(status_id);
      this.get_applyto_list();
      this.get_configuration_by_schoolid();
    });
  }

  render() {
    
    return (
      <div className="row">
        <div className="col-12">
          <div className=' d-flex align-items-center justify-content-between mb-4'>
            <div className="same-close-button-left">
              <button onClick={this.hideEditSection.bind(this)}><img src="/media/resources/close.png" alt="Images" />Close</button>
            </div>
            {(this.state.saupdatestatus)&&
              <Dropdown>
                <Dropdown.Toggle variant="" className="dropdown-toggle menu-drop btn btn_style_2 py-2 px-4 fsize13">
                  Actions
                  <div className="action-button-arrow"><i className="fa fa-angle-down" aria-hidden="true"></i></div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu adjust">
                  <Dropdown.Item onClick={this.editItem.bind(this,'editable')}>Edit</Dropdown.Item>
                  <Dropdown.Item onClick={this.delete_status.bind(this,this.state.status_id)}>Delete</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            }
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Applied To: <span style={{ color: 'red' }}>*</span></label>
              </div>
            </div>
            <div className="col-5">
              <div className="single-change-password-right-input">
                <select className="form-control form-control2" value={this.state.applied_to} onChange={this.handleInput.bind(this, 'applied_to')} disabled>
                  <option value="">Select</option>
                  {this.state.applyto_list != null && this.state.applyto_list.map((c, i) => {
                    return (
                      <option value={c.value} key={i}>{c.label}</option>
                    )
                  })}
                </select>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Status Name: <span style={{ color: 'red' }}>*</span></label>
              </div>
            </div>
            <div className="col-5">
              <div className="single-change-password-right-input">
                <input type="search" className='form-control form-control2 w-100' placeholder="Search…" value={this.state.status_name} id="status_name" onChange={this.handleInput.bind(this, 'status_name')} disabled={this.state.view_mode == 'readonly'} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Status State: <span style={{ color: 'red' }}>*</span></label>
              </div>
            </div>
            <div className="col-5">
              <div className="single-change-password-right-input">
                <input type="search" className='form-control form-control2 w-100' placeholder="Search…" value={this.state.status_state} id="status_state" onChange={this.handleInput.bind(this, 'status_state')} disabled={this.state.view_mode == 'readonly'} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Initial:</label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="initial">
                  <input type="checkbox" id="initial" name="initial" value={1} onChange={this.handleCheckbox.bind(this, 'initial')} checked={this.state.initial == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>Default initial status.</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Status Comment: </label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="status_comment">
                  <input type="checkbox" id="status_comment" name="status_comment" value={1} onChange={this.handleCheckbox.bind(this, 'status_comment')} checked={this.state.status_comment == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>Requiring comments whenever this status is applied.</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Block Access:</label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="block_access">
                  <input type="checkbox" id="block_access" name="block_access" value={1} onChange={this.handleCheckbox.bind(this, 'block_access')} checked={this.state.block_access == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>For Student only, this will block Student from accessing system.</label>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>System Only:</label>
              </div>
            </div>
            <div className="col-5">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="system_only">
                  <input type="checkbox" id="system_only" name="system_only" value={1} onChange={this.handleCheckbox.bind(this, 'system_only')} checked={this.state.system_only == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Withdrawn Enrollment:</label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="withdrawn_enrollment">
                  <input type="checkbox" id="withdrawn_enrollment" name="withdrawn_enrollment" value={1} onChange={this.handleCheckbox.bind(this, 'withdrawn_enrollment')} checked={this.state.withdrawn_enrollment == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>For Student only, this status will change all enrollment status to "Withdrawn".</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Off Limit:</label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="off_limit">
                  <input type="checkbox" id="off_limit" name="off_limit" value={1} onChange={this.handleCheckbox.bind(this, 'off_limit')} checked={this.state.off_limit == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>For Student only. When a Student is in this status, then no modifications can be made on the Student’s records.</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="single-change-password-right-input">
                <label>Terminating: </label>
              </div>
            </div>
            <div className="col-1">
              <div className="single-change-password-right-input">
                <label className="custom-checkbox" htmlFor="terminating">
                  <input type="checkbox" id="terminating" name="terminating" value={1} onChange={this.handleCheckbox.bind(this, 'terminating')} checked={this.state.terminating == 1} disabled={this.state.view_mode == 'readonly'} />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-8">
              <div className="single-change-password-right-input">
                <label style={{textTransform: 'none'}}>Final state.</label>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-3">
            </div>
            <div className="col-5">
              {this.state.error_message && <div className="row col-12 mb-2" style={{color:'red'}}>{this.state.error_message}</div>}
              {this.state.view_mode == 'editable' &&
                <button className="btn_style_1" onClick={this.save_status.bind(this)}>Save</button>
              }
              <button className="btn_style_2 ml-2" onClick={this.hideEditSection.bind(this)}>Cancel</button>
            </div>
          </div>

          <div className="load-spiner fixed-loading">
            {
              (this.state.loaderspiner == true) ?
                <ReactLoading type="spinningBubbles" color="#00BFFF" height={100} width={100} /> : ''
            }
          </div>
          {
            (this.state.showAlert == true) ?
              <div id="alert-message">
                <AlertList
                  position={this.state.position}
                  alerts={this.state.alerts}
                  //timeout={this.state.timeout}
                  dismissTitle=""
                  onDismiss={this.onAlertDismissed.bind(this)}
                />
              </div> : ''
          }
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditStatus)